<div class="p-4">
  <button (click)="onReset()" class="lum-button lum-button--secondary mb-2">
    Reset
  </button>
  <mat-radio-group
    aria-label="Select an option"
    [(ngModel)]="selectedValue"
    (change)="onRadioChange($event)"
  >
    <div *ngFor="let option of options; trackBy: trackById">
      <mat-radio-button [value]="option.id">{{ option.label }}</mat-radio-button>
    </div>
  </mat-radio-group>
</div>
